var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('th',{staticClass:"vertical-top"},[_vm._v(_vm._s(_vm.name)),(_vm.required)?_c('span',{staticClass:"required"}):_vm._e()]),_c('td',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }